import withItemsFetcher from '@/hocs/withItemsFetcher';

import AutocompleteAPI from './component';

export default withItemsFetcher(AutocompleteAPI);
